import {
  KioskLayout,
  AuthInKioskLayout,
  KioskProtectedLayout,
} from '@/layouts';
import { EKioskRouterNames } from '@/types';
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { kioskPublicRoutes } from './kioskPublicRoutes';
import { kioskPrivateRoutes } from './kioskPrivateRoutes';

const KioskLanding = lazy(() => import('../../pages/Kiosk/pages/KioskLanding'));

export const kioskRoutes: RouteObject[] = [
  {
    path: EKioskRouterNames.KIOSK,
    element: <KioskLayout />,
    children: [
      {
        element: <AuthInKioskLayout />,
        children: [
          {
            element: <KioskProtectedLayout />,
            children: [
              { index: true, element: <KioskLanding /> },
              ...kioskPrivateRoutes,
            ],
          },
          ...kioskPublicRoutes,
        ],
      },
    ],
  },
];
